module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.5178/img/business-types/ecommerce.png"